/**
 * Horizon filtering re-renders the grid only, so the hero would stay frozen. On
 * a `filter.` change in the URL it re-renders itself through the Section
 * Rendering API; the section id is data-hero-sync on the hero root.
 */
(function () {
  if (window.bqColHeroSync) return;
  var hero = document.querySelector('[data-hero-sync]');
  if (!hero) return;
  var id = hero.dataset.heroSync;
  var wrap = document.getElementById('shopify-section-' + id);
  if (!wrap) return;
  window.bqColHeroSync = true;

  var seq = 0;
  function filterKey() {
    var out = [];
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') === 0) out.push(k + '=' + v);
    });
    return out.sort().join('&');
  }

  var last = filterKey();
  function refresh() {
    var now = filterKey();
    if (now === last) return;
    last = now;
    var mine = ++seq;
    var join = location.search ? '&' : '?';
    fetch(location.pathname + location.search + join + 'section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html || mine !== seq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id);
        if (fresh) {
          wrap.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () { /* best-effort: the manual refresh stays correct */ });
  }

  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    history[m] = function () {
      var r = orig.apply(this, arguments);
      setTimeout(refresh, 0);
      return r;
    };
  });
  window.addEventListener('popstate', refresh);
})();
